<template>
  <div class="bg-white border border-gray-300 rounded-2xl shadow-sm hover:shadow-md transition overflow-hidden">
    <div class="p-4">
      <h3 class="text-lg font-bold text-gray-900 mb-2">{{ announcement.title }}</h3>

      <div class="text-xs text-gray-500 space-y-1">
        <p>
          <!-- <span class="font-medium text-gray-600">Компания:</span>
          <span class="text-gray-500">{{ announcement.author_name }}</span> -->
          <span v-if="announcement.created_at">
            • <span class="text-gray-500">{{ formatDate(announcement.created_at) }}</span>
          </span>
          <span v-if="announcement.budget">
            • <span class="font-medium text-gray-600">Бюджет:</span> <span class="text-gray-500">{{ announcement.budget }}</span>
          </span>
        </p>
      </div>
    </div>

    <div class="border-t border-gray-200"></div>

    <div class="p-4">
      <p class="text-gray-600 mb-4 line-clamp-3">{{ announcement.description }}</p>

      <div v-if="announcement.services && announcement.services.length > 0" class="mb-4">
        <div class="text-xs text-gray-500 font-medium mb-2">Услуги:</div>
        <div class="flex flex-wrap gap-2">
          <span
            v-for="service in announcement.services"
            :key="service"
            class="inline-block px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
          >
            {{ getServiceLabel(service) }}
          </span>
        </div>
      </div>

      <div v-if="announcement.required_pilot_category" class="text-xs text-gray-500">
        <span class="font-medium text-gray-600">Категория:</span> <span class="text-gray-500">{{ getPilotCategoryLabel(announcement.required_pilot_category) }}</span>
      </div>
    </div>

    <div class="border-t border-gray-200 p-4">
      <button
        @click="openDetail"
        class="px-4 py-2 bg-white border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 transition text-sm font-medium"
      >
        Подробнее
      </button>
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { API_PILOT_SERVICES_PUBLIC, HEADERS_TOKEN_JSON } from '@/const/uri';

let servicesCache = null;
let servicesFetching = false;

export default {
  name: 'AnnouncementCard',
  components: {},
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  emits: ['refresh'],
  setup(props) {
    const router = useRouter();
    const serviceLabelMap = ref({});

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return new Intl.DateTimeFormat('ru-RU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    };

    const getPilotCategoryLabel = (category) => {
      const labels = {
        first: 'Первая категория',
        second: 'Вторая категория',
        third: 'Третья категория',
        fourth: 'Четвертая категория',
      };
      return labels[category] || category;
    };

    const getServiceLabel = (service) => {
      if (serviceLabelMap.value && serviceLabelMap.value[service]) {
        return serviceLabelMap.value[service];
      }
      return service;
    };

    const fetchServiceLabels = async () => {
      if (servicesCache) {
        serviceLabelMap.value = servicesCache;
        return;
      }

      if (servicesFetching) {
        const maxWait = 50;
        let waited = 0;
        while (servicesFetching && waited < maxWait) {
          await new Promise(resolve => setTimeout(resolve, 100));
          waited += 100;
        }
        if (servicesCache) {
          serviceLabelMap.value = servicesCache;
        }
        return;
      }

      servicesFetching = true;
      try {
        const response = await axios.get(API_PILOT_SERVICES_PUBLIC.list, {
          headers: HEADERS_TOKEN_JSON()
        });

        const services = response.data.data || [];
        servicesCache = {};
        services.forEach(service => {
          servicesCache[service.key] = service.name;
        });
        serviceLabelMap.value = servicesCache;
      } catch (error) {
        console.error('Error fetching pilot services:', error);
      } finally {
        servicesFetching = false;
      }
    };

    const openDetail = () => {
      router.push({
        name: 'PilotAnnouncementDetail',
        params: { id: props.announcement.id }
      });
    };

    onMounted(() => {
      fetchServiceLabels();
    });

    return {
      formatDate,
      getPilotCategoryLabel,
      getServiceLabel,
      openDetail,
    };
  },
};
</script>

<style scoped>
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
